import React from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAgencySettingsOptions, editGeneralAgencySettingsOptions } from '@generated';
import Yup from '~/util/yup';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { AddressFormField } from '~/shared/forms/controls/fields/AddressFormField';
import { SettingsIcon } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibraryForm } from '../shared/LibraryForm';

export const GeneralAgencySettingsSection = {
	settingsView: 'general',
	title: 'General Settings',
	description: 'Manage basic agency information and contact details',
	TitleIcon: SettingsIcon
} satisfies SettingsSectionItem;

const validationSchema = Yup.object().shape({
	name: Yup.string().label('Agency Name').nullable().required(),
	npiNumber: Yup.string().label('Agency NPI Number').nullable(),
	address: Yup.object().label('Agency Address').address().required()
});

export function GeneralAgencySettingsForm() {
	const { data: settings } = useSuspenseQuery(getAgencySettingsOptions());

	return (
		<LibraryForm
			initialValues={{
				name: settings.name,
				npiNumber: settings.npiNumber,
				address: settings.address
			}}
			saveMutation={editGeneralAgencySettingsOptions}
			validationSchema={validationSchema}
			{...GeneralAgencySettingsSection}
		>
			<TextFormField name="name" />
			<TextFormField name="npiNumber" />
			<AddressFormField name="address" />
		</LibraryForm>
	);
}
